import { render, staticRenderFns } from "./DeviceMonitorResult.vue?vue&type=template&id=027f2c72&scoped=true"
import script from "./DeviceMonitorResult.vue?vue&type=script&lang=js"
export * from "./DeviceMonitorResult.vue?vue&type=script&lang=js"
import style0 from "./DeviceMonitorResult.vue?vue&type=style&index=0&id=027f2c72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027f2c72",
  null
  
)

export default component.exports